import { Box, Text } from '@bpba/ui-components';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { MdLogout } from 'react-icons/md';
import { UrlsFront } from '../constants/urls';

type LogoutProps = {
  children: React.ReactNode;
};

export const Logout = ({ children }: LogoutProps) => {
  const navigate = useNavigate();

  return (
    <StyledBox
      onClick={() => {
        localStorage.removeItem('token');
        localStorage.removeItem('customerName');
        navigate(UrlsFront.LogIn);
      }}
      backgroundColor={'transparent'}
      alignItems={'center'}
      borderRadius={'4px'}
      fontWeight={'500'}
      width={'fit-content'}
    >
      <Text textAlign="center" fontSize={'11px'}>
        {children}
      </Text>
      <MdLogout size={22} />
    </StyledBox>
  );
};

const StyledBox = styled(Box)({
  ':hover': {
    opacity: '0.7',
    cursor: 'pointer',
  },
});
